import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CountryOfOrgin } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class CountryOfOriginApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly COUNTRY_OF_ORIGIN_URL = `${this.apiServer}/country-of-origin`;

    getCountryOfOriginList(): Observable<CountryOfOrgin[]> {
        return this.http.get<CountryOfOrgin[]>(this.COUNTRY_OF_ORIGIN_URL);
    }
}